export default __webpack_public_path__ + "static/media/content.a309666c.svg";